namespace $ {

	export class $shm_hitalama_map_access_catalog extends $giper_baza_pawn {

		static shard_seed( recipient: string ) {
			return 0xA11000 + $giper_baza_link.hash_str( recipient ).toBin()[0]
		}

		shard_link( recipient: string ) {
			let idea = $shm_hitalama_map_access_catalog.shard_seed( recipient )
			// Match area_make(seed) without creating an area during a read.
			while( true ) {
				idea = this.$.$mol_hash_numbers([ idea ])
				if( !idea ) continue
				const area = this.$.$giper_baza_link.from_int( idea ).str
				if( /[æÆ]/.test( area ) ) continue
				return new this.$.$giper_baza_link( this.land().link().lord().str + '_' + area )
			}
		}

		@ $mol_mem_key
		shard( recipient: string ) {
			// Reading an area's Sands does not read the registry root. Keep its
			// synchronization alive explicitly: inherit() only reads local root
			// rights, so a cold client otherwise never downloads the POST grant.
			this.land().sync()
			return this.$.$giper_baza_glob.Land( this.shard_link( recipient ) ).sync()
		}

		@ $mol_action
		publish( map: $giper_baza_land, recipient: $giper_baza_auth_pass, active: boolean, title = '', backfill = false ) {
			const shard = this.shard( recipient.lord().str )
			// sync_rights() starts inheritance but does not await it. Cold areas
			// must finish copying signed root rights before their first post.
			shard.inherit()
			const auth = shard.auth()
			const issuer = auth.pass().lord()
			if( shard.lord_rank( issuer ) < this.$.$giper_baza_rank_post( 'just' ) ) {
				$mol_fail( new Error( 'Invitation registry does not permit publishing' ) )
			}
			const authority = backfill ? this.land().sync() : map
			if( authority.lord_rank( issuer ) < this.$.$giper_baza_rank_rule ) {
				$mol_fail( new Error( backfill ? 'Only a registry administrator can index historical grants' : 'Only a map administrator can publish an invitation' ) )
			}
			const gift = map._gift.get( recipient.lord().str )
			if( !gift ) return false
			if( active && gift.rank() < this.$.$giper_baza_rank_read ) {
				$mol_fail( new Error( 'Grant map access before publishing an invitation' ) )
			}
			const data: $shm_hitalama_map_access_invitation_data = {
				version: 1, recipient: recipient.lord().str, map: map.link().str,
				grant_time: gift.time_tick(), active, title: title || map.link().str,
				... backfill ? { backfill: true as const } : {},
			}
			if( !this.$.$shm_hitalama_map_access_invitation.parse( data ) ) {
				$mol_fail( new Error( 'Invalid map invitation' ) )
			}
			const head = this.$.$shm_hitalama_map_access_index.recipient_head( data.recipient )
			const self = this.$.$shm_hitalama_map_access_envelope.slot([ auth, recipient, data.map ])
			const body = JSON.stringify( data )
			const previous = shard.sand_get( head, issuer, self )
			if( previous && !previous.dead() ) {
				shard.sands_open([ previous ])
				const packed = shard.sand_decode( previous )
				if( typeof packed === 'string' ) {
					const opened = this.$.$shm_hitalama_map_access_envelope.open([ auth, recipient, packed ])
					const stored = this.$.$shm_hitalama_map_access_invitation.parse( JSON.parse( opened ) )
					if( stored && stored.map !== data.map ) $mol_fail( new Error( 'Map invitation address collision' ) )
					if( opened === body ) return false
				}
			}
			const packed = this.$.$shm_hitalama_map_access_envelope.seal([ auth, recipient, body ])
			const posted = shard.post( this.$.$giper_baza_link.hole, head, self, packed )
			if( shard.sand_get( head, issuer, self ) !== posted ) {
				$mol_fail( new Error( 'Invitation was not accepted by the local registry' ) )
			}
			return true
		}

		@ $mol_mem_key
		candidate( [ shard, sand, auth ]: readonly [ $giper_baza_land, $giper_baza_unit_sand, $giper_baza_auth ] ) {
			const pass = shard.lord_pass( sand.lord() )
			if( !pass ) return null
			shard.sands_open([ sand ])
			const packed = shard.sand_decode( sand )
			if( typeof packed !== 'string' ) return null
			const body = this.$.$shm_hitalama_map_access_envelope.open([ auth, pass, packed ])
			const data = this.$.$shm_hitalama_map_access_invitation.parse( JSON.parse( body ) )
			if( !data || data.recipient !== auth.pass().lord().str ) return null
			if( sand.self().str !== this.$.$shm_hitalama_map_access_envelope.slot([ auth, pass, data.map ]).str ) return null
			return { signer: sand.lord(), data }
		}

		/** Discovery candidates are deliberately not yet trusted map accesses. */
		@ $mol_mem_key
		candidates( auth: $giper_baza_auth ) {
			const recipient = auth.pass().lord().str
			const shard = this.shard( recipient )
			const head = this.$.$shm_hitalama_map_access_index.recipient_head( recipient )
			return this.$.$shm_hitalama_map_access_index.authored_units( shard, head )
				.flatMap( sand=> {
					const candidate = this.$.$mol_error_fence(
						()=> this.candidate([ shard, sand, auth ]),
						()=> null,
						()=> null,
					)
					return candidate ? [ candidate ] : []
				} )
		}

	}

}
